module.exports = __webpack_public_path__ + "img/cave47.fe5c76f5.jpg";